import React from 'react';
import { Button } from './ui/Button';
import { Sparkles } from 'lucide-react';
export function CallToAction() {
  return <section className="py-24 bg-gradient-to-br from-red-900 via-red-800 to-red-900 relative overflow-hidden" data-id="element-26">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-27"></div>

      <div className="container mx-auto px-4 text-center relative z-10 max-w-4xl" data-id="element-28">
        <div className="inline-block p-3 rounded-full bg-white/10 backdrop-blur-sm mb-8 animate-bounce" data-id="element-29">
          <Sparkles className="w-8 h-8 text-amber-400" data-id="element-30" />
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-black text-white mb-6 leading-tight" data-id="element-31">
          Transformá tus clases con el <br data-id="element-32" />
          <span className="text-amber-400" data-id="element-33">MegaPack Música Lista</span>
        </h2>

        <p className="text-xl md:text-2xl text-red-100 max-w-2xl mx-auto mb-10 leading-relaxed font-medium" data-id="element-34">
          Accedé hoy mismo a cientos de recursos, planificaciones y dinámicas.
          Volvé a disfrutar enseñar… y también tu tiempo libre.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-35">
          <a href="https://bolivia.edulabs.online/cart/44072226848851:1" target="_blank" rel="noopener noreferrer" data-id="element-36">
            <Button size="lg" variant="secondary" className="text-xl font-black px-10 py-6 shadow-2xl shadow-amber-900/50 hover:scale-105 transform transition-all" data-id="element-37">
              ¡Quiero el MegaPack ahora!
            </Button>
          </a>
        </div>

        <p className="mt-6 text-sm text-red-200 opacity-90 font-medium" data-id="element-38">
          Acceso inmediato • Pago seguro • Garantía de satisfacción
        </p>
      </div>
    </section>;
}